import { render, staticRenderFns } from "./BotaoExcluir.vue?vue&type=template&id=1d760987&scoped=true"
import script from "./BotaoExcluir.vue?vue&type=script&lang=js"
export * from "./BotaoExcluir.vue?vue&type=script&lang=js"
import style0 from "./BotaoExcluir.vue?vue&type=style&index=0&id=1d760987&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d760987",
  null
  
)

export default component.exports